import { useParams } from "react-router-dom";
import ProfileView from "../components/ProfileView.component";
import { theme } from "../configs/theme";
import { RootContainer } from "../styles/Container.style";
import { Title } from "../styles/Text";
import { Column, Gap } from "../styles/Utils";

export default function ProfileViewPage() {
  const { profileId } = useParams();

  if (!profileId) {
    return (
      <Column $alignItem="center" $justifyContent="flex-start" $maxHeight>
        <Gap $height={5} />
        <Title $color={theme.color.primaryDark}>No Profile Data</Title>
      </Column>
    );
  }

  return (
    <RootContainer $background={theme.color.primaryExtraLight}>
      <ProfileView profileId={profileId} />
    </RootContainer>
  );
}
